import React from 'react'
import { Text, View } from 'react-native'
import { twMerge } from 'tailwind-merge'

import { getFontColor } from '@ui-kit/components/Bars/TopBar/utils'
import ButtonIcon from '@ui-kit/components/ButtonIcon'
import { body2 } from '@ui-kit/core/typography'
import { bgColor } from '@ui-kit/styles/colors'

import type { NativeProps } from './types'

const TopBar = (props: NativeProps): JSX.Element => (
  <View
    className={twMerge(
      'flex flex-row items-center justify-center gap-x-2.5 bg-playground4-light p-2.5',
      props.bgColor && bgColor({ color: props.bgColor })
    )}
  >
    {props.iconLeft && <ButtonIcon icon={props.iconLeft} onPress={props.onIconPress} />}
    {props.text ? (
      <Text
        className={body2({
          bold: props.isBold,
          color: getFontColor(props.bgColor),
        })}
      >
        {props.text}
      </Text>
    ) : (
      props.content
    )}
    {props.iconRight && <ButtonIcon icon={props.iconRight} onPress={props.onIconPress} />}
  </View>
)

export default TopBar
